import { render, staticRenderFns } from "./BarAfterDesign.vue?vue&type=template&id=3b7d1bf7"
import script from "./BarAfterDesign.vue?vue&type=script&lang=js"
export * from "./BarAfterDesign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports